// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"5ce49c12","84":"0cddfe8f","148":"eed1acf9","344":"f45d5e17","392":"87ca1500","436":"148f217f","472":"be7cfe7b","496":"b26b3dc4","552":"a9082303","684":"9690b791","696":"71c5fdaa","872":"9beda88e","968":"917c045a"}[chunkId] + ".chunk.js";
};